import React from 'react';
import 'twin.macro';
import { Tag } from 'components/Tag';

interface Props {
  supervision?: string;
  interactive?: boolean;
}

export function SupervisionTag(props: Props) {
  const { interactive, supervision } = props;
  return (
    <Tag interactive={interactive} color="lavande-quiet" tw="rounded-md">
      {supervision}
    </Tag>
  );
}
